
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/about.en.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/about.en.md?type=demo')
};